import { render, staticRenderFns } from "./AnnouncementPage.vue?vue&type=template&id=e61418b6&scoped=true&lang=pug"
import script from "./AnnouncementPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementPage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPage.vue?vue&type=style&index=0&id=e61418b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61418b6",
  null
  
)

export default component.exports